import { generatedVars } from './generated/vars';

export const vars = generatedVars;
